// Core React Imports
import React from "react";

// Local Imports
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import WidgetInputBase from "../widget-input-base/WidgetInputBase";

// CSS/Stylesheets
import "./WidgetInputSecond.css";

const WidgetInputSecond = ({
  value,
  onChange,
  heightProp = "4.4rem",
  widthProp = "8rem",
  textAlignProp = "center",
  showOverlayText = false,
  paddingRightProp = "0rem",
  rightPropText = "auto",
  fontFamilyProp,
  disabled = false,
}) => {
  return (
    <DivColumn className="model-2-frame-11" style={{ height: heightProp, width: widthProp }}>
      <div className="model-2-frame-12">
        <DivColumn className="model-2-frame-13" style={{ position: "relative" }}>
          <WidgetInputBase style={{ textAlign: textAlignProp, paddingRight: paddingRightProp, fontFamily: fontFamilyProp }} value={value} onChange={onChange} disabled={disabled} />
          {showOverlayText && (
            <ParagraphText className={`overlay-text-1 ${disabled ? "disabled" : ""}`} style={{ right: rightPropText }}>
              %
            </ParagraphText>
          )}
        </DivColumn>
      </div>
    </DivColumn>
  );
};

export default WidgetInputSecond;
